import { twMerge } from "tailwind-merge"

type ClassValue = string | number | false | null | undefined

/**
 * Junta classes condicionais e resolve conflitos do Tailwind (via twMerge).
 * Ex.: cn("px-4", isActive && "bg-primary", "px-6") -> "bg-primary px-6"
 */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(inputs.filter(Boolean).join(" "))
}
